var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDndIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45816 2.9166C2.26348 2.9166 2.91632 2.2637 2.91632 1.4583C2.91632 0.652904 2.26348 0 1.45816 0C0.65284 0 0 0.652904 0 1.4583C0 2.2637 0.65284 2.9166 1.45816 2.9166Z",
    fill: "#171717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54166 2.9166C9.34698 2.9166 9.99982 2.2637 9.99982 1.4583C9.99982 0.652904 9.34698 0 8.54166 0C7.73634 0 7.0835 0.652904 7.0835 1.4583C7.0835 2.2637 7.73634 2.9166 8.54166 2.9166Z",
    fill: "#171717"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45816 9.97129C2.26348 9.97129 2.91632 9.31839 2.91632 8.51299C2.91632 7.70759 2.26348 7.05469 1.45816 7.05469C0.65284 7.05469 0 7.70759 0 8.51299C0 9.31839 0.65284 9.97129 1.45816 9.97129Z",
    fill: "#171717"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54166 9.97129C9.34698 9.97129 9.99982 9.31839 9.99982 8.51299C9.99982 7.70759 9.34698 7.05469 8.54166 7.05469C7.73634 7.05469 7.0835 7.70759 7.0835 8.51299C7.0835 9.31839 7.73634 9.97129 8.54166 9.97129Z",
    fill: "#171717"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45816 17.0104C2.26348 17.0104 2.91632 16.3574 2.91632 15.552C2.91632 14.7467 2.26348 14.0938 1.45816 14.0938C0.65284 14.0938 0 14.7467 0 15.552C0 16.3574 0.65284 17.0104 1.45816 17.0104Z",
    fill: "#171717"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54166 17.0104C9.34698 17.0104 9.99982 16.3574 9.99982 15.552C9.99982 14.7467 9.34698 14.0938 8.54166 14.0938C7.73634 14.0938 7.0835 14.7467 7.0835 15.552C7.0835 16.3574 7.73634 17.0104 8.54166 17.0104Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDndIcon);
export default __webpack_public_path__ + "static/media/dnd-icon.0a8cbbb810eac7779f0bd5695968c53c.svg";
export { ForwardRef as ReactComponent };